import AudioRecorderContainer, {
	type AudioRecorderContainerRef,
} from "@features/session/containers/AudioRecorderContainer";
import useAIFeedbackStore from "@features/session/hooks/useAIFeedbackStore";
import { useCallback } from "react";

type Props = {
	itemId: number;
	currentQuestionAnswered?: boolean;
	currentUserResponse?: unknown;
	maximumDuration?: number;
	audioRecorderContainerRef?: React.RefObject<AudioRecorderContainerRef>;
};

const Speaking = ({
	itemId,
	currentQuestionAnswered,
	currentUserResponse,
	maximumDuration,
	audioRecorderContainerRef,
}: Props) => {
	const streaming = useAIFeedbackStore((state) => state.streaming);
	const setUserResponse = useAIFeedbackStore((state) => state.setUserResponse);

	const handleSetAudioUri = useCallback(
		(uri: string | undefined) => {
			setUserResponse(itemId, uri);
		},
		[itemId, setUserResponse],
	);

	return (
		<AudioRecorderContainer
			ref={audioRecorderContainerRef}
			key={itemId}
			itemId={itemId}
			recordedAudio={currentUserResponse as string | undefined}
			handleSetAudioUri={handleSetAudioUri}
			disabled={streaming}
			showDiscardButton={!currentQuestionAnswered}
			maxDuration={maximumDuration}
		/>
	);
};

export default Speaking;
